/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateCustomerStatisticsInput = {
    description?: string | null | undefined;
    name: string;
    wavecareBoxIds?: Record<string, any> | null | undefined;
};
export type apiCreateCustomerStatisticsMutationVariables = {
    input: CreateCustomerStatisticsInput;
};
export type apiCreateCustomerStatisticsMutationResponse = {
    readonly createCustomerStatistics: {
        readonly customerStatistics: {
            readonly id: string;
            readonly name: string;
            readonly description: string;
            readonly wavecareBoxIds: Record<string, any>;
        };
    };
};
export type apiCreateCustomerStatisticsMutation = {
    readonly response: apiCreateCustomerStatisticsMutationResponse;
    readonly variables: apiCreateCustomerStatisticsMutationVariables;
};



/*
mutation apiCreateCustomerStatisticsMutation(
  $input: CreateCustomerStatisticsInput!
) {
  createCustomerStatistics(input: $input) {
    customerStatistics {
      id
      name
      description
      wavecareBoxIds
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCustomerStatisticsPayload",
    "kind": "LinkedField",
    "name": "createCustomerStatistics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomerStatistics",
        "kind": "LinkedField",
        "name": "customerStatistics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wavecareBoxIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiCreateCustomerStatisticsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "apiCreateCustomerStatisticsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1abc4bded909514b9dea79153072d6c4",
    "id": null,
    "metadata": {},
    "name": "apiCreateCustomerStatisticsMutation",
    "operationKind": "mutation",
    "text": "mutation apiCreateCustomerStatisticsMutation(\n  $input: CreateCustomerStatisticsInput!\n) {\n  createCustomerStatistics(input: $input) {\n    customerStatistics {\n      id\n      name\n      description\n      wavecareBoxIds\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '5ef6295a7e1fcef9bd3c0f922497f1cd';
export default node;
